var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mark',{staticClass:"eventLabel",class:{ 'eventLabel--disabled': _vm.disabled },style:({
    color: _vm.color,
    'background-color': _vm.hasIcon ? 'transparent' : _vm.bgColor,
    'font-size': _vm.fontSize,
    border: _vm.borderColor ? `1px solid ${_vm.borderColor}` : 'none',
  })},[(_vm.hasIcon)?[_c('img',{attrs:{"src":_vm.icon}})]:(_vm.small)?[_c('v-tooltip',{attrs:{"top":"","content-class":"eventLabel_tooltip "},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text.charAt(0)))])]}}])},[_c('h2',[_vm._v(_vm._s(_vm.text))])])]:[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }